<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">{{ pageTitle }}</div>
    </div>
    <div class="page-body">
      <div class="video" @click="goToVideo">
        <img :src="dataImg.fileImageUrl" class="videoImg" />
        <div class="videoDivTime">
          {{ formattedTime }}
        </div>
        <img src="@/assets/aiVideo/sybf.png" alt="#" class="bodyTop-sybf" />
      </div>
      <div class="button">
        <div @click="godo('1')">下载</div>
        <div @click="godo('2')">转发</div>
      </div>
    </div>
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text">
            下载与转发属于订阅付费功能，付费后可正常使用下载与转发
          </div>
        </div>
        <div class="modal-confirm-div">
          <div class="modal-confirm-btn" @click="closeModal">返回</div>
          <div class="modal-confirm-btn-ff">去付费</div>
        </div>
      </div>
    </div>
    <div v-if="showModalUrl" class="modal-overlay" @click="closeModalUrl">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text messageUrl">
            {{ this.message }}
          </div>
        </div>
        <div class="modal-confirm-div">
          <div class="modal-confirm-btn" @click="closeModalUrl">关闭</div>
          <div class="modal-confirm-btn-ff" @click="handleCopyText">复制</div>
        </div>
      </div>
    </div>
    <FullScreenVideo
      :src="videoSrc"
      @error="handleVideoError"
      @goBack="goBack"
      v-if="showVideo"
    />
  </div>
</template>
<script>
import { getTalkingVideoOne, getUserIsMember } from "@/api";
import FullScreenVideo from "@/components/fullScreenVideo.vue";

export default {
  name: "creationDetail",
  components: { FullScreenVideo },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.spTime / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.spTime % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  data() {
    return {
      showModalUrl: false,
      showVideo: false,
      showModal: false,
      userType: false,
      dataImg: {},
      videoSrc: "",
      spTime: "",
      pageTitle: "",
      message: "",
	  currentPlatform: '',
    };
  },
  mounted() {
    this.pageTitle =
      this.$route.query.formPath == "aiVideo" ? "创作记录" : "我的作品";
	  document.title = this.pageTitle;
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    this.haveUserType();
    this.haveDetail();
  },
  methods: {
    goToVideo() {
      this.showVideo = true;
    },
    goBack() {
      this.showVideo = false;
    },
    handleVideoError(error) {
      this.$toast && this.$toast(error);
    },
    //获取是否为会员
    async haveUserType() {
      let data = await getUserIsMember();
      this.userType = data == 0 ? false : true;
    },

    async haveDetail() {
      let data = await getTalkingVideoOne({ id: this.$route.query.id });
      this.dataImg = data;
      this.videoSrc = data.subtitleVideoUrl
        ? data.subtitleVideoUrl
        : data.videoUrl;
      this.spTime = data.videoTime;
    },
    // 返回按钮逻辑
    onBack() {
      this.$router.push({ path: this.$route.query.formPath });
    },
    closeModal() {
      this.showModal = false;
    },
    closeModalUrl() {
      this.showModalUrl = false;
    },

    // 复制文本（空方法）
    handleCopyText() {
      // 1. 拼接标题+内容，中间空一行（处理空值，避免多余空行）
      let copyContent = this.message;
      if (!copyContent) {
        this.$toast("暂无可复制的内容");
        return;
      }

      // 2. 兼容浏览器剪贴板API
      if (navigator.clipboard && window.isSecureContext) {
        // 现代浏览器安全上下文
        navigator.clipboard
          .writeText(copyContent)
          .then(() => {
            this.$toast("标题和内容已复制到剪贴板");
          })
          .catch((err) => {
            console.error("剪贴板复制失败：", err);
            this.fallbackCopyTextToClipboard(copyContent); // 传递拼接后的内容到降级方案
          });
      } else {
        // 降级方案（兼容非安全上下文/旧浏览器）
        this.fallbackCopyTextToClipboard(copyContent);
      }
    },

    // 复制降级方案（修改：接收拼接后的内容参数）
    fallbackCopyTextToClipboard(copyContent) {
      const textArea = document.createElement("textarea");
      textArea.value = copyContent; // 使用拼接后的内容
      // 防止滚动到页面外
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand("copy");
        const msg = successful
          ? "视频链接已复制成功，请进入浏览器打开"
          : "复制失败，请手动复制";
        this.$toast(msg);
      } catch (err) {
        console.error("降级复制失败：", err);
        this.$toast("复制失败，请手动复制");
      }
      document.body.removeChild(textArea);
    },
    godo(type) {
      //不是会员
      // if (!this.userType) {
      //   return (this.showModal = true);
      // }
      if (type == "1") {
        this.downloadVideo();
      }
      //下面写是会员的逻辑
    },
    async downloadVideo() {
      const { videoSrc } = this;

      // 1. 检查是否在微信中（常见拦截场景）
      const isInWechat = /micromessenger/i.test(navigator.userAgent);
      if (isInWechat) {
        this.message = videoSrc;
        this.showModalUrl = true;
        return;
      }

      // 2. 判断是否为 iOS
      // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      // if (isIOS) {
      //   // iOS 无法自动下载，必须引导
      //   alert(
      //     "📱 保存视频到 iPhone：\n" +
      //       "1. 点击 Safari 地址栏右侧【分享】按钮\n" +
      //       "2. 向下滑动，选择【存储到文件】\n" +
      //       "（部分视频可选【保存视频】存入相册）",
      //   );
      //   return;
      // }

      // 3. Android / 桌面端：尝试强制下载
      try {
        // 关键：必须支持 CORS！
        const response = await fetch(videoSrc, {
          method: "GET",
          mode: "cors",
        });

        if (!response.ok) throw new Error("视频加载失败");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = "作品.mp4"; // 自定义文件名
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放内存
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      } catch (err) {
        console.error("下载失败:", err);

        // 降级：新窗口打开（用户可手动长按保存）
        if (
          confirm(
            "无法直接下载，是否在新窗口打开视频？\n(Android 用户可长按视频选择“下载”)",
          )
        ) {
          window.open(videoSrc, "_blank", "noopener,noreferrer");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  /* overflow-y: auto; */
  padding: 5.333vw 0 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.video {
  width: 85.333vw;
  height: calc(100vh - 44vw);
  height: calc(100dvh - 44vw);
  border-radius: 4.2666vw;
  background-color: #d8d8d8;
  box-shadow: 0px 0px 1.0666 0px rgba(0, 0, 0, 0.1);
  position: relative;
}
.videoImg {
  width: 85.333vw;
  height: calc(100vh - 44vw);
  height: calc(100dvh - 44vw);
  border-radius: 4.2666vw;
  object-fit: cover;
}
.bodyTop-sybf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8vw;
  height: 8vw;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2.9333vw;
  margin-bottom: 7.9333vw;
  width: 100vw;
  box-shadow: 0px -0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  margin-top: 5.6vw;
}
.button > div:nth-child(1) {
  width: 29.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  margin-right: 3.2vw;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  line-height: 8vw;
  text-align: center;
}
.button > div:nth-child(2) {
  width: 29.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  line-height: 8vw;
  text-align: center;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  /* height: 58.666vw; */
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-text {
  width: 67.2vw;
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
  text-align: center;
}
.messageUrl {
  word-break: break-all; /* 强制在任意字符间换行（包括英文/数字） */
  overflow-wrap: break-word; /* 更智能的换行（优先在空格/连字符处断） */
  white-space: normal;
}
.modal-confirm-div {
  display: flex;
  justify-content: center;
  margin-top: 6.5333vw;
  margin-bottom: 5.333vw;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  margin-right: 5.333vw;
}
.modal-confirm-btn-ff {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  line-height: 10.666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
}
.videoDivTime {
  position: absolute;
  bottom: 5.0666vw;
  left: 10vw;
  height: 7.8666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 5.333vw;
  text-align: left;
}
</style>
